export default "__VITE_ASSET__Ds90$DTe__"